import { Dispatch, SetStateAction } from "react";
import { TabsOKRMODAL } from "src/components/OrgChart/objectives/interface";
import IGroupersDTO from "src/Interfaces/groupersDTO";

export interface IListOKRs{
    oka001Id: number;
    oka001Codigo: string;
    oka001Titulo: string;
    oka001Efa005Nome: string;
    oka001Efa005Imagem: string;
    oka001Periodo: string;
    oka001Nivel: number;
    oka001Taa001Nome: string;
    percent: number;
    colorGraph: string;
    oka001Dtinicio: Date;
    oka001Dtfim: Date;
    level: number;
    permissions?: number;
}

interface IGroupersOKR extends IGroupersDTO<IGroupersOKR>{
    image: string | null;
}

export enum GroupersOKR {
    RESPONSIBLE = "1",
    AUTHORITY = "2",
    LEVEL = "3",
    SECTOR = "4",
    PERIOD = "5"
}

export interface IFiltersOKR{ 
    f: string ;
    responsible: string | undefined;
    authority: string | undefined;
    sector: string | undefined;
    tags: string | undefined;
    startDate?: Date | null;
    endDate?: Date | null;
    level: string | undefined;
    okrId: string | null;
}

export interface IGroupersSelect{
    group: GroupersOKR;
    list: "P" | "T";
}

export interface IListOfOKRs{
    data?: IListOKRs[];
    layoutList: "card" | "list";
    callbackOnDelete: Function;
	callbackOnUpdate: Function;
	onViewHierarchy: Function;
	openModalDelete?: (id: number, title: string, onCallback?: Function) => void;
    openModalAddOrChange?: (id?: number, okrParentId?: number, onCallback?: Function, tabInitSelected?: TabsOKRMODAL | undefined) => void;
	openModalOKRComments?: (id: number, titleOkr: string, onCallback?: Function, disabled?: boolean) => void;
	openModalOKRAttachments?: (id: number, titleOkr: string, onCallback?: Function,  disabled?: boolean) => void;
}

export interface IGrouperOfOKRs{
    grouper: IGroupersOKR;
    layoutList: "card" | "list";
	onViewHierarchy: Function;
    filters: IFiltersOKR;
    groupersSelect: IGroupersSelect;
	openModalDelete?: (id: number, title: string, onCallback?: Function) => void;
    openModalAddOrChange?: (id?: number, okrParentId?: number, onCallback?: Function, tabInitSelected?: TabsOKRMODAL | undefined) => void;
	openModalOKRComments?: (id: number, titleOkr: string, onCallback?: Function, disabled?: boolean) => void;
	openModalOKRAttachments?: (id: number, titleOkr: string, onCallback?: Function, disabled?: boolean) => void;
}

export interface IHierarchyOKR{
    setView: Dispatch<SetStateAction<"list" | "hierarchy">>;
}

export default IGroupersOKR;
